import './style.scss';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { FormikProps } from 'formik';
import { PurchaseSimulationInput, useITExplanationPageStore } from '../hooks';
import { DateFormatType, formatDate } from 'views/utils/converter';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { DomesticRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';
export type DomesticRealEstateItExplanationRequestConfirmProps = {
  symbolDetail: DomesticRealEstateSymbolDetailInfo;
  formik: FormikProps<PurchaseSimulationInput>;
  backDetailPage: () => void;
};
export const DomesticRealEstateItExplanationSymbolApplyConfirm = ({
  symbolDetail,
  formik,
  backDetailPage,
}: DomesticRealEstateItExplanationRequestConfirmProps) => {
  useCustomLocationName('重要事項説明書の電子交付・IT重説のお申込み確認');
    const { param } = useITExplanationPageStore();
  

  return (
    <>
      <div className="domesticRealEstateItExplanation_requestConfirm">
        <div>
        IT重説を以下の日程で申し込みますが、よろしいですか？
        </div>
        <div className='domesticRealEstateItExplanation_requestConfirm_reservationDateTime'>
         <div>＜予約日時＞</div>
         <div>・第1希望：{formatDate(param.meetingDate1, DateFormatType.Slash_yyyyMMdd)}　{param.meetingTime1}</div>
         <div>・第2希望：{formatDate(param.meetingDate2, DateFormatType.Slash_yyyyMMdd)}　{param.meetingTime2}</div>
         <div>・第3希望：{formatDate(param.meetingDate3, DateFormatType.Slash_yyyyMMdd)}　{param.meetingTime3}</div>
        </div>

        <div className="domesticRealEstateItExplanation_requestConfirm_targetSymbol">
          <div>＜対象案件＞</div>
          <div>{symbolDetail.ProductName}</div>
        </div>

        <div className="domesticRealEstateItExplanation_requestConfirm_buttons">
          <Button
            label={'電子交付・IT重説を申込む'}
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.medium}
            onClick={formik.handleSubmit}
          />
          <Button
            label="案件詳細画面へ戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={backDetailPage}
          />
        </div>
      </div>
    </>
  );
};
